import { render } from "./companyCard.vue?vue&type=template&id=7d2d1764&scoped=true"
import script from "./companyCard.vue?vue&type=script&lang=js"
export * from "./companyCard.vue?vue&type=script&lang=js"

import "./companyCard.vue?vue&type=style&index=0&id=7d2d1764&scoped=true&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2d1764"]])

export default __exports__